import { getAllSettings } from 'api/globalSettings'
import { useEffect, useState } from 'react'
import { GlobalSettings } from 'types/GlobalSettings'

export const useGlobalSettings = (ticketCount?: number, ticketTotalPrice?: number) => {
    const [globalSettings, setGlobalSettings] = useState<GlobalSettings | null>(null)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<Error | null>(null)

    useEffect(() => {
        const fetchSettings = async () => {
            setIsLoading(true)
            try {
                const fetched = await getAllSettings()
                setGlobalSettings(fetched)
            } catch (err: any) {
                setError(new Error('A beállítások betöltése sikertelen.'))
            } finally {
                setIsLoading(false)
            }
        }
        fetchSettings()
    }, [])

    const systemFee = globalSettings?.system_usage_fee_per_ticket ?? 0
    const totalSystemFee = ticketCount ? systemFee * ticketCount : 0
    const grandTotal = ticketTotalPrice !== undefined ? ticketTotalPrice + totalSystemFee : undefined

    return {
        globalSettings,
        isLoading,
        error,
        systemFee,
        totalSystemFee,
        grandTotal,
    }
}
